import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import * as R from 'ramda'

import ValidatedInput from '../ValidatedInput'
import {
  upperAndLowerCaseValidator,
  digitsValidator,
  minLengthValidator,
  specialCharValidator
} from '../../../helpers/validationRules'
import {
  ErrorComponent,
  SuccessComponent,
  NeutralErrorComponent
} from '../DefaultTooltipComponents'
import styles from './validatedPasswordInput.module.scss'

const ValidatedPasswordInput = React.forwardRef(
  (
    {
      message,
      rules,
      header,
      error,
      showErrorAsNeutral,
      successIcon,
      errorIcon,
      onChange,
      ...restProps
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false)
    const [value, setValue] = useState('')
    const vRules = rules || [
      {
        match: upperAndLowerCaseValidator,
        successMessage: message.upperAndLower,
        errorMessage: message.upperAndLower
      },
      {
        match: digitsValidator,
        successMessage: message.digits,
        errorMessage: message.digits
      },
      {
        match: minLengthValidator(8),
        successMessage: message.minLength,
        errorMessage: message.minLength
      },
      {
        match: R.allPass([
          R.complement(specialCharValidator),
          minLengthValidator(1)
        ]),
        successMessage: message.specialChar,
        errorMessage: message.specialChar
      }
    ]

    const shouldReserveSpace = R.anyPass(vRules.map((rule) => rule.match))(
      value
    )

    const myRef = React.createRef()

    React.useEffect(() => {
      ref && ref(myRef.current)
    }, [myRef.current])
    return (
      <div className={styles.container}>
        <ValidatedInput
          ErrorComponent={
            showErrorAsNeutral === true
              ? NeutralErrorComponent({
                  successIcon,
                  errorIcon,
                  shouldReserveSpace
                })
              : ErrorComponent({ successIcon, errorIcon })
          }
          SuccessComponent={SuccessComponent({ successIcon, errorIcon })}
          rules={vRules}
          type={visible ? 'text' : 'password'}
          ref={myRef}
          defaultVisible
          header={!error && header}
          error={error}
          showErrorAsNeutral={showErrorAsNeutral}
          onChange={(event) => {
            setValue(event.target.value)
            onChange && onChange(event)
          }}
          {...restProps}
        />
        <div className={styles.seePassword}>
          <span
            onClick={(event) => {
              myRef.current.focus()
              setVisible(!visible)
            }}
          >
            {visible ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>
    )
  }
)

ValidatedPasswordInput.propTypes = {
  message: PropTypes.shape({
    upperAndLower: PropTypes.string,
    digits: PropTypes.string,
    minLength: PropTypes.string
  }),
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      match: PropTypes.func,
      successMessage: PropTypes.string,
      errorMessage: PropTypes.string
    })
  )
}

export default ValidatedPasswordInput
